<template>
  <div>
    <div class="advance-search">
      <div class="block">
        <div class="block-content">
          <el-form :model="information" ref="informationForm">
            <div class="form-row">
              <el-form-item v-if="skin === 'pvm' || skin === 'tkl'" class="hotel-item" prop="hotel" :label="$t('Hotel Tower')">
                  <el-input
                    class="el-select del-forbid"
                    :value="information.hotelName"
                    spellcheck="false"
                  >
                    <i slot="prefix" class="el-icon-date el-input__icon"></i>
                  </el-input>
              </el-form-item>
               <el-form-item v-else :label="$t('Select Hotel')" class="hotel-form" prop="hotel" required>
                <el-select v-model="information.hotel" :placeholder="$t('Please select a hotel')"
                           >
                  <template #prefix>
                    <i class="el-icon-date el-input__icon"></i>
                  </template>

                  <el-option v-for="(hotel,index) of hotels" :label="hotel.name" :value="hotel.code"
                             :key="index"/>
                </el-select>
              </el-form-item>
              <el-form-item class="qty-control date-item" prop="Arrival" :label="$t('Arrival Date')" required>
                <i class="el-icon-minus" @click="qtyControl(-1,'Arrival')"/>
                <el-input
                  @focus="openCalendar"
                  readonly
                  :placeholder="$t('Arrival Date')"
                  prefix-icon="el-icon-date"
                  :value="information.Arrival | dateFormat(that)"/>
                <i class="el-icon-plus" @click="qtyControl(1,'Arrival')"/>
              </el-form-item>
              <el-form-item class="qty-control date-item" prop="Departure" :label="$t('Departure Date')" required>
                <i class="el-icon-minus" @click="qtyControl(-1,'Departure')"/>
                <el-input
                  @focus="openCalendar"
                  readonly
                  :placeholder="$t('Departure Date')"
                  prefix-icon="el-icon-date"
                  :value="information.Departure | dateFormat(that)"/>
                <i class="el-icon-plus" @click="qtyControl(1,'Departure')"/>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item :label="$t('Rooms & Guests')" class="rooms-inputs" :class="{'show-guests':showGuests}">
                <div class="event-box" @click.stop="toggleGuests">
                  <el-input
                    readonly
                    prefix-icon="el-icon-present"
                    suffix-icon="el-icon-arrow-down"
                    :value="$t('{0}Rooms/{1}Adults,{2}Children',
                    [information.rooms,information.Adults,information.Children])"/>
                </div>
                <div class="input-group" v-show="showGuests" @click.stop>
                  <i class="el-icon-close" @click="showGuests=false" v-if="0"></i>
                  <el-form-item :label="$t('Rooms')+$t(':')">
                    <el-input-number :precision="0" @focus="toReadonly" v-model="information.rooms" :min="1" :max="9"
                                     label="Adults Per Room"/>
                  </el-form-item>
                  <el-form-item :label="$t('Adults Per Room')+$t(':')">
                    <span class="input-tips">({{ $t('Maximum 4 Guests per Room') }})</span>
                    <el-input-number :precision="0" @focus="toReadonly" @change="qtyFix" v-model="information.Adults"
                                     :min="1" :max="3"
                                     label="Adults Per Room"/>
                  </el-form-item>
                  <el-form-item :label="$t('Child Per Room')+$t(':')" class="child-form">
                    <span class="input-tips">({{ $t('Maximum 4 Guests per Room') }})</span>
                    <el-input-number :precision="0" @focus="toReadonly" v-model="information.Children" :min="0"
                                     :max="maxChild"
                                     label="Child Per Room"/>
                  </el-form-item>
                </div>
              </el-form-item>

              <el-form-item prop="Departure" :label="$t('Promotion Code')">
                <el-input
                  prefix-icon="el-icon-present"
                  v-model="information.Promotion"/>
              </el-form-item>

              <div class="el-form-item actions">
                <el-button type="primary" class="action-search" @click.prevent="search">
                  {{ $t('SEARCH') }}
                </el-button>
                <router-link :to="{name:'Search', query:{skin: skin}}">{{ $t('Manage Booking') }}</router-link>
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <silk-popup :show="showCalendar" @popup-close="showCalendar=false" class="calendar-popup">
      <price-calendar
        ref="priceCalendar"
        v-on:calendar-submit="dayInput"
        @hotel-change="hotelChange"
        :hotel_code="information.hotel"
        :initDay="{
            day0:information.Arrival,
            day1:information.Departure
          }"/>
    </silk-popup>
  </div>
</template>

<script>
import util from '@/util';
import PriceCalendar from '@/components/PriceCalendar.vue'
import {mapState} from 'vuex'

export default {
  name: 'AdvanceSearch',
  props: {},
  data() {
    return {
      information: {
        Arrival: '',
        Departure: '',
        Adults: 2,
        Children: 0,
        hotel: '',
        rooms: 1,
        Promotion: '',
        hotelName:''
      },
      hotels: [],
      showCalendar: false,
      showGuests: false,
    }
  },
  components: {
    PriceCalendar,
  },
  methods: {
    /*
    * @method { Function } getInfos 获取信息通用方法
    * @param { String } url 请求地址
    * @param { String } dataKey 本地属性名
    * @param { String } resKey 远程属性名
    * @param { Object } data 请求配置信息
    * */
    getInfos(url, dataKey, resKey, data = {}) {
      return this.axios.get(url, data)
        .then((res) => {
            if (res.code === 200) {
              this[dataKey] = res.data[resKey]
            }
          }
        )
    },

    search() {
      const d = this.information
      const params = {
        arrival_date: d.Arrival,
        departure_date: d.Departure,
        rooms: d.rooms.toString(),
        adults: d.Adults.toString(),
        children: d.Children.toString(),
        hotel_code: d.hotel,
        skin: this.skin
      }
      if (d.Promotion) {
        params.promotion_code = d.Promotion
      }
      const other = {
        session_id: util.getCookie('session_id') || 0,
        group_by: this.$route.query.group_by || 'room_type_cate',
        lang: this.$route.query.lang,
        skin: this.skin
      }
      let query = Object.assign(params, other)
      if (JSON.stringify(query) === JSON.stringify(this.$route.query)) {
        this.$router.replace('/refresh')
        return
      }
      this.$refs.informationForm.validate((valid) => {
        if (valid) {
          this.$store.commit('stateChange', {k: 'SearchParams', v: params})
          this.$router.push({
            'name': 'SelectRoom',
             query,
          })
        }
      });
    },
    dayInput(time) {
      this.information.Arrival = util.dateStr(time.startDay)
      this.information.Departure = util.dateStr(time.endDay)
      this.showCalendar = false
    },
    hotelChange(code) {
      this.information.hotel = code
    },
    qtyControl(num, date) {
      //没有值时禁用
      if (!this.information[date]) {
        return
      }
      let yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      let newDay = new Date(util.dateArr(this.information[date]));
      newDay.setDate(newDay.getDate() + num);
      //禁止选今天之前的日期
      if (newDay.getTime() < yesterday.getTime()) {
        return;
      }
      //禁止起始日期小于结束日期
      if (date === 'Arrival' && newDay.getTime() >= new Date(util.dateArr(this.information.Departure)).getTime()) {
        return;
      }
      if (date === 'Departure' && newDay.getTime() <= new Date(util.dateArr(this.information.Arrival)).getTime()) {
        return;
      }

      this.information[date] = util.dateStr(newDay)
    },
    openCalendar() {
      this.$refs.priceCalendar.init()
      this.showCalendar = true;
    },
    initData() {
      this.getInfos('/api/nonemember/info/hotels', 'hotels', 'hotels').then(
        () => {
          this.$store.commit('stateChange', {k: 'hotels', v: this.hotels})
          this.information.hotelName = this.hotels[0].name
          if (this.$route.name === 'SelectRoom') {
            const data = this.$route.query;
            this.information.Adults = data.adults
            this.information.Arrival = data.arrival_date
            this.information.Children = data.children
            this.information.Departure = data.departure_date
            this.information.Promotion = data.promotion_code
            this.information.hotel = data.hotel_code
            this.information.rooms = data.rooms
          }
        }
      );
    },
    autoInputDay() {
      let date = new Date()
      //开业逻辑
      if (this.openDayActive && this.notOpening) {
        date = new Date(util.dateArr(this.notOpening))
      }
      this.information.Arrival = util.dateStr(date)
      date.setDate(date.getDate() + 1)
      this.information.Departure = util.dateStr(date)
    },
    toReadonly(event) {
      event.target.setAttribute('readonly', 'readonly');
    },
    qtyFix(n) {
      if (n === 3 && this.information.Children) {
        this.information.Children = 0
      }
    },
    toggleGuests() {
      this.showGuests = !this.showGuests
    }
  },
  created() {
    this.initData()
    document.onclick = () => {
      if (this.$route.name === 'Home' || this.$route.name === 'SelectRoom') {
        this.showGuests = false
      }
    }
  },
  computed: {
    ...mapState(['gaData']),
    maxChild() {
      return this.information.Adults === 3 ? 0 : 2
    },
    //是否需要验证开业日期
    openDayActive() {
      return !this.$store.state.onceSubmit && !this.showCalendar
    },
    curHotel() {
      return this.hotels.find(hotel => hotel.code === this.information.hotel);
    },
    notOpening() {
      let openDay = this.curHotel.opening_date
      if (new Date() > new Date(util.dateArr(openDay))) {
        openDay = false
      }
      return openDay
    },
    skin() {
      return this.gaData.skinCode
    }
  },
  watch: {
    'information.hotel'() {
      if (this.$route.name === 'Home' && this.openDayActive) {
        this.autoInputDay()
      }
    }
  }
}
</script>
